export const OCCUPATIONS = [
  "Unemployed","Teacher","Engineer","Doctor","Nurse","Lawyer","Accountant","Business Owner","Student","Government Officer","Private Sector Employee","Other"
].map(o => ({ value:o, label:o }));